var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$style.formCard,
    _vm.strong && _vm.$style.strong,
    _vm.windowsWidth <=700 && _vm.$style.mobileFormCard
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }